import {
    CheshireRecordType,
    CheshireRecordSubType
} from "./CheshireRecordTypes";

import {
    IRecordTypeFeatureInfoClick,
    RecordTypeResource,
    IRecordTypeHeading,    
    IMappingTextPack
} from "@esdm/map";
import { ILayerGroup } from "@esdm/map/dist/layers/groups/ILayerGroup";


let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: CheshireRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monuments"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Event,
        recordSubTypeCode: null,
        heading: "Events"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designations"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.AreaArchaeologicalImportance,
        heading: "Area of Archaeological Importance"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.AreaArchaeologicalPotential,
        heading: "Areas of Archaeological Potential"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.AreaSpecialArchaeologicalPotential,
        heading: "Area of Special Archaeological Potential"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.ListedBuilding,
        heading: "Listed Buildings"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.LocallyListedBuilding,
        heading: "LocallyListed Buildings"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.RegisteredParksAndGardens,
        heading: "Registered Parks and Gardens"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.RegisteredBattlefields,
        heading: "Registered Battlefields"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.ScheduledMonument,
        heading: "Scheduled Monuments"
    });  

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.ConservationArea,
        heading: "Conservation Areas"
    });

    items.push({
        recordTypeCode: CheshireRecordType.Designation,
        recordSubTypeCode: CheshireRecordSubType.WorldHeritageSite,
        heading: "World Heritage Site"
    });

    items.push({
        recordTypeCode: CheshireRecordType.HLC,
        recordSubTypeCode: CheshireRecordSubType.UADCharacterZones,
        heading: "Archaeological Character Zones"
    });
    
    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === CheshireRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        return {
            id: featureProperties.id,
            uid: featureProperties.uid,
            ref: featureProperties.ref,
            name: featureProperties.name,
            recordType: featureProperties.rectype,
            recordSubType: featureProperties.recsubtype,
            recordSubTypeCode: featureProperties.recsubtypecode,
            data: featureProperties,
            heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
            layerGroup: layerGroup
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string 
    {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = recordTypeInfoClick.layerGroup.layerType;

        //add controller (or any arbitrary data) to the data object
        switch (recordTypeInfoClick.recordType.toLowerCase()) {
            case "mon":                
                recordTypeInfoClick.data.controller = "Monument";               
                break;
            case "event":
                recordTypeInfoClick.data.controller = "Event";               
                break;
            case "desig":
                recordTypeInfoClick.data.controller = "Designation";               
                break;           
        }

        if (recordTypeInfoClick.recordSubTypeCode.toUpperCase() === CheshireRecordSubType.UADCharacterZones) {
            html = `
                         <li>
                            <span>[name] ([significance])</span>               
                            <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                                <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                            </a>
                         </li>`;
        } else { 
            html = `
                         <li>
                            <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                            &nbsp;
                            <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}">                               
                                <span>[name]</span>               
                            </a>
                            <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                                <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                            </a>
                         </li>`;
        }
        return html;
    }

    
}